<ng-template #template>
  <div class="modal-header">
    <div class="modal-title flex-grow-1">
      {{ 'REMINDERS' | translate }}
    </div>
    <div>
      <button type="button" class="btn btn-icon" aria-label="Close" (click)="close(); controlRecurrenceEvents()">
        <i class="fa-regular fa-xmark fa-gray fa-normal"></i>
      </button>
    </div>
  </div>
  @if (!(isAlarmsLoading && (remindersList || []).length > 1)) {
    @if (remindersList && remindersList.length > 0) {
      <div class="modal-body">
        <div class="d-flex selected-reminder">
          <div class="pr-2"><i class="fa-regular fa-calendar fa-gray fa-normal"></i></div>
          @if (selectedReminders) {
            <div class="content-overflow">
              @if (selectedReminders.length === 1) {
                <p
                  class="b1-r mb-0 content-overflow pointer"
                  (dblclick)="navigateToEventDetail(selectedReminders[0])"
                  [innerHTML]="selectedReminders[0].alarm_info.name | sanitizeAndEncodeHtml"></p>
                <p class="mb-0 content-overflow">
                  {{ selectedReminders[0].alarm_info.alarm_instance_start | date: 'd' }}
                  {{ selectedReminders[0].alarm_info.alarm_instance_start | date: 'MMMM' | uppercase | translate }}
                  {{ selectedReminders[0].alarm_info.alarm_instance_start | date: 'EEEE' | uppercase | translate }}
                  {{ selectedReminders[0].alarm_info.alarm_instance_start | date: 'y, HH:mm' }}
                  ({{ selectedReminders[0].alarm_info.relative_time.substring(0, 1) | uppercase
                  }}{{ selectedReminders[0].alarm_info.relative_time.substring(1) }} {{ selectedReminders[0].alarm_info.relative_key | translate }})
                </p>
                @if (selectedReminders[0].alarm_info.location) {
                  <p class="mb-0 content-overflow" [innerHTML]="selectedReminders[0].alarm_info.location | sanitizeAndEncodeHtml | linky"></p>
                }
              } @else {
                <p class="mb-0 content-overflow h8-r">{{ selectedReminders.length }} {{ 'REMINDERS_SELECTED' | translate }}</p>
              }
            </div>
          }
        </div>
        @if (remindersList.length > 1) {
          <div class="mt-3">
            <div class="form-group b-all remindersList">
              @for (reminder of remindersList; track reminder; let i = $index) {
                <div
                  class="custom-control custom-checkbox text-left reminder-item"
                  [ngClass]="{ 'input-show': selectedReminders.length > 0, 'bg-secondary': reminder.checked }"
                  (dblclick)="navigateToEventDetail(reminder)">
                  <label class="checkbox-container mb-0">
                    <span
                      class="content-overflow w-50 d-inline-block robot_reminder_timeInfo{{ i }}"
                      [innerHTML]="reminder.alarm_info.name | sanitizeAndEncodeHtml"></span>
                    <span class="float-right text-right text-claret-red content-overflow w-50" [ngClass]="{ 'text-claret-red': reminder.inPast }"
                      >{{ reminder.alarm_info.relative_time.substring(0, 1) | uppercase }}{{ reminder.alarm_info.relative_time.substring(1) }}
                      {{ reminder.alarm_info.relative_key | translate }}
                    </span>
                    <input
                      type="checkbox"
                      [checked]="reminder.checked"
                      [value]="reminder"
                      name="{{ reminder.alarm_info.name }}"
                      (change)="select($event.target.checked, reminder)"
                      autocomplete="off" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  } @else {
    <app-skeleton-loader-reminder></app-skeleton-loader-reminder>
  }
  <div class="modal-footer border-top-0">
    <div class="d-flex justify-content-end" [ngClass]="{ unclickable: isAlarmsLoading }">
      <div class="btn-group mr-2" dropdown [isDisabled]="selectedReminders.length === 0">
        <button dropdownToggle type="button" class="btn btn-small btn-secondary dropdown-toggle" aria-controls="dropdown-dropup">
          {{ 'BUTTON_SNOOZE' | translate }}
          <i class="fa-regular fa-chevron-down fa-primary fa-normal"></i>
        </button>
        <ul *dropdownMenu class="dropdown-menu border-0 rounded py-0" role="menu" aria-labelledby="button-dropup">
          @for (snoozeOption of snoozeOptions; track snoozeOption) {
            <li role="menuitem">
              <button
                class="dropdown-item"
                (click)="
                  snoozeOption.key !== 'SNOOZE_AT_EVENT_HOUR'
                    ? snoozeReminders(snoozeOption.duration, snoozeOption.type, snoozeOption.negativeDuration)
                    : snoozeReminders()
                "
                [disabled]="snoozeOption.disabled">
                {{ snoozeOption.key | translate }}
              </button>
            </li>
          }
        </ul>
      </div>
      @if (remindersList.length > 1) {
        <div class="btn-group" dropdown [isDisabled]="selectedReminders.length === 0">
          <button dropdownToggle type="button" class="btn btn-small btn-secondary dropdown-toggle" aria-controls="dropdown-dropup">
            {{ 'BUTTON_DISMISS' | translate }}
            <i class="fa-regular fa-chevron-down fa-primary fa-normal"></i>
          </button>
          <ul *dropdownMenu class="dropdown-menu border-0 rounded py-0" role="menu" aria-labelledby="button-dropup">
            <li role="menuitem">
              <a class="dropdown-item" (click)="dismiss(selectedReminders)">{{ 'DISMISS_EVENT' | translate }}</a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" (click)="dismiss(remindersList)">{{ 'DISMISS_ALL' | translate }}</a>
            </li>
          </ul>
        </div>
      } @else {
        <button type="button" [disabled]="selectedReminders.length === 0" class="btn btn-small btn-primary" (click)="dismiss(selectedReminders)">
          {{ 'BUTTON_DISMISS' | translate }}
        </button>
      }
    </div>
  </div>
</ng-template>
